import React from 'react';
import { Link, NavLink } from 'react-router-dom';
import { LayoutGridIcon, Workflow as WorkflowIcon, HeartHandshakeIcon, Globe2Icon, SettingsIcon, ExternalLinkIcon, SearchIcon, NewspaperIcon, RocketIcon } from 'lucide-react';
import { LogOutIcon } from 'lucide-react';
import { cn } from '../ui/cn';
import { endStudioSession, type StudioSession } from '../../data/teamAccess';
const nav = [{
  to: '/studio',
  label: 'Mission Control',
  icon: LayoutGridIcon,
  end: true
}, {
  to: '/studio/website',
  label: 'Website Studio',
  icon: Globe2Icon
}, {
  to: '/studio/press-kit',
  label: 'Press Kit',
  icon: NewspaperIcon
}, {
  to: '/studio/search',
  label: 'Search Visibility',
  icon: SearchIcon
}, {
  to: '/studio/fans',
  label: 'Fans & VIP',
  icon: HeartHandshakeIcon
}, {
  to: '/studio/automation',
  label: 'Automation Studio',
  icon: WorkflowIcon
}, {
  to: '/studio/settings',
  label: 'Settings',
  icon: SettingsIcon
}, {
  to: '/studio/launch',
  label: 'Launch',
  icon: RocketIcon
}];
interface SidebarProps {
  session: StudioSession;
  onSignOut: () => void;
}
export function Sidebar({
  session,
  onSignOut
}: SidebarProps) {
  const signOut = () => {
    void endStudioSession();
    onSignOut();
  };
  return <aside className="hidden md:flex w-[248px] shrink-0 flex-col border-r border-white/[0.06] bg-ink-900 px-3 py-5" data-id="element-478" data-mp="1mast42ghexwf">
      <div className="flex items-center gap-2.5 px-3 pb-6" data-id="element-479" data-mp="1i6l2u0udl9w3">
        <div className="flex h-8 w-8 items-center justify-center rounded-lg bg-accent shadow-glow" data-id="element-480" data-mp="2exvoilpv2sig">
          <span className="text-sm font-bold text-white" data-id="element-481" data-mp="2a0wz2gh579ql">A</span>
        </div>
        <div className="leading-none" data-id="element-482" data-mp="25xqsf7q4bgjl">
          <div className="text-[15px] font-semibold tracking-tight text-white" data-id="element-483" data-mp="25wp6u9bh7bnm">ArtistOS</div>
          <div className="text-[11px] text-zinc-500" data-id="element-484" data-mp="20ydyk30tx97i">AI Career Manager</div>
        </div>
      </div>

      <nav className="flex flex-1 flex-col gap-0.5" data-id="element-485" data-mp="ukod0fzr8x10">
        {nav.map(({
        to,
        label,
        icon: Icon,
        end
      }) => <NavLink key={to} to={to} end={end} className={({
        isActive
      }) => cn('group relative flex items-center gap-3 rounded-xl px-3 py-2.5 text-[13.5px] font-medium transition-colors', isActive ? 'bg-white/[0.07] text-white' : 'text-zinc-400 hover:bg-white/[0.04] hover:text-zinc-100')} data-id="element-486" data-mp="pip7azgjlo0w">
            {({
          isActive
        }) => <>
                {isActive && <span className="absolute left-0 top-1/2 h-5 w-[3px] -translate-y-1/2 rounded-r-full bg-accent" data-id="element-487" data-mp="d1wm0cyt9on2" />}
                <Icon className="h-[18px] w-[18px]" strokeWidth={1.9} data-id="element-488" data-mp="3uj7crtjvc7kw" />
                {label}
              </>}
          </NavLink>)}
      </nav>

      <Link to="/" className="mt-4 flex items-center gap-3 rounded-xl border border-white/[0.06] bg-ink-850 px-3 py-2.5 text-[13px] font-medium text-zinc-300 transition-colors hover:border-accent/40 hover:text-white" data-id="element-489" data-mp="3lgofrq2rkp6k">
        <ExternalLinkIcon className="h-[18px] w-[18px] text-accent-soft" strokeWidth={1.9} data-id="element-490" data-mp="36v128nr2giwo" />
        View public site
      </Link>

      <div className="mt-2 flex items-center gap-3 rounded-xl border border-white/[0.06] bg-ink-850 px-3 py-2.5" data-id="element-491" data-mp="31xr3ghhseuw6">
        <img src="https://cdn.magicpatterns.com/patterns/generated-images/09f81107-e411-4ff0-8bc3-a6403da9c809.jpg" alt="Cooper Howington" className="h-8 w-8 rounded-full object-cover ring-1 ring-white/10" data-id="element-492" data-mp="3btu5lncn2tj4" />
        <div className="min-w-0 flex-1 leading-tight" data-id="element-493" data-mp="3ktr1a8xg4sno">
          <div className="truncate text-[13px] font-medium text-white" data-id="element-494" data-mp="3div6ij4bfxb">{session.name}</div>
          <div className="truncate text-[11px] capitalize text-zinc-500" data-id="element-495" data-mp="3ukbx5olqjj2w">{session.role}</div>
        </div>
        <button type="button" onClick={signOut} aria-label="Sign out" className="shrink-0 rounded-lg p-1.5 text-zinc-500 transition-colors hover:bg-white/[0.06] hover:text-white" data-id="element-496" data-mp="ce79lecfbiaq">
          <LogOutIcon className="h-4 w-4" data-id="element-497" data-mp="21ujanojlz1mb" />
        </button>
      </div>
    </aside>;
}